import { ReactComponent as NextArrowIcon } from '@Icons/additional/arrow-left.svg';
import { ReactComponent as DownloadIcon } from '@Icons/additional/download.svg';
import { ReactComponent as SearchIcon } from '@Icons/additional/search.svg';

import ActionButtons from '@Components/Confirmation/mobile/component/ActionButtons/ActionButtons';

import styles from './tender-confirm-mobile.module.css';

interface TenderConfirmMobileProps {
  backToText?: string;
  caption?: string;
  actions?: JSX.Element | null;
  content?: JSX.Element | null;
  hidePagination?: boolean;
  disableConfirm?: boolean;
  handleBack: () => void;
  handleConfirm: () => void;
}

const TenderConfirmMobile: React.FC<TenderConfirmMobileProps> = ({
  handleBack,
  handleConfirm,
  disableConfirm,
  actions,
  content,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <NextArrowIcon onClick={handleBack} />
        <div>Tender Confirmation</div>
        <div className={styles.actions}>
          <DownloadIcon className={styles.icon} />
          <SearchIcon className={styles.icon} />
        </div>
      </div>
      <div className={styles.navigationTabs}>
        <div className={styles.actionGroup}>{actions}</div>
      </div>
      <div className={styles.content}>{content}</div>
      <div className={styles.actionButtons}>
        <ActionButtons
          handleBack={handleBack}
          handleConfirm={handleConfirm}
          disableConfirm={disableConfirm}
          withoutInfoSection
        />
      </div>
    </div>
  );
};

export default TenderConfirmMobile;
